import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-red"
}
const _hoisted_2 = {
  key: 1,
  class: "row tw-w-2/3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex-grow" }, null, -1)
const _hoisted_4 = { class: "row tw-w-2/3 tw-justify-center" }

import { LanguageChoice } from '../../i18n'
import { computed, ref } from 'vue'
import RecapPage from './RecapPage.vue'
import { useI18n } from 'vue-i18n'
import { useSharedRecap } from '../../composables/recaps/useRecap'
import { logInfo } from '../../utils'

type LanguageChoiceOption = { label: string; value: LanguageChoice }

export default /*#__PURE__*/_defineComponent({
  __name: 'RecapDefinition',
  props: {
    recapId: {},
    taskOrStoreId: {},
    recapType: { default: 'task' },
    testingTaskId: { default: undefined },
    testingRecap: { type: Boolean },
    previewRecap: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const { t } = useI18n({ useScope: 'global' })

const {
  getPageRef,
  getRecapResponse,
  resetRecap,
  setUpComposable,
  recapLanguage,
  allPages,
  pageOptions,
  selectedPage,
  selectPage,
  submittingRecap,
  canSubmitRecap,
  errorSubmittingRecap,
} = useSharedRecap()

const languageChoice = ref<LanguageChoice>(recapLanguage.value)
const languageOptions: LanguageChoiceOption[] = [
  { label: 'English', value: 'en_US' },
  { label: 'Français', value: 'fr_CA' },
  { label: 'Español', value: 'es_MX' },
]

const selectedPageIndex = computed(() =>
  pageOptions.value.findIndex((page) => selectedPage.value?.value === page.value)
)

const isFirstPage = computed(
  () => pageOptions.value.findIndex((page) => page.value === selectedPage.value?.value) === 0
)
const isLastPage = computed(
  () =>
    pageOptions.value.findIndex((page) => page.value === selectedPage.value?.value) ===
    pageOptions.value.length - 1
)

// Recap Submission
async function submitRecap() {
  canSubmitRecap.value = false
  submittingRecap.value = true
  const recapResponse = await getRecapResponse()
  if (recapResponse && typeof recapResponse === 'object' && !('validationError' in recapResponse)) {
    const recapResponseEvent = new CustomEvent<{ response: object }>('recapResponse', {
      detail: {
        response: recapResponse,
      },
    })
    window.dispatchEvent(recapResponseEvent)
  }
}

// Expose the resetRecap function for explicit cleanup
__expose({
  resetRecap,
  getRecapResponse,
})

// Set up the recap
setUpComposable(
  props.recapId,
  props.recapType,
  props.taskOrStoreId,
  props.testingRecap,
  props.testingTaskId,
  props.previewRecap
)
  .then(() =>
    selectPage(0).catch((err) => {
      logInfo('error', 'RecapDefinitionLoadingError', 'First recap page failed to select', {
        error: err,
        recapId: props.recapId,
      })
    })
  )
  .catch((err) => {
    logInfo('error', 'RecapDefinitionLoadingError', 'Recap definition failed to load', {
      error: err,
      recapId: props.recapId,
    })
  })

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "full-width column items-center tw-my-6" }, {
    default: _withCtx(() => [
      (_unref(errorSubmittingRecap))
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _createElementVNode("strong", null, _toDisplayString(_unref(t)('recap.validationError', 0, { locale: _unref(recapLanguage) })), 1)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allPages), (page) => {
        return _withDirectives((_openBlock(), _createBlock(RecapPage, {
          key: `${_ctx.recapType}-${_ctx.taskOrStoreId}-${page.value}`,
          ref_for: true,
          ref: (_unref(getPageRef) as any),
          "page-id": page.value
        }, null, 8, ["page-id"])), [
          [_vShow, page.value === _unref(selectedPage)?.value]
        ])
      }), 128)),
      (_unref(pageOptions).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!isFirstPage.value)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  push: "",
                  color: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(selectPage)(selectedPageIndex.value - 1)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('recap.page.back', 0, { locale: _unref(recapLanguage) })), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _hoisted_3,
            (!isLastPage.value)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  push: "",
                  color: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(selectPage)(selectedPageIndex.value + 1)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('recap.page.next', 0, { locale: _unref(recapLanguage) })), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (isLastPage.value && props.testingRecap && !_ctx.previewRecap)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 2,
                  push: "",
                  color: "green",
                  onClick: submitRecap
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('recap.page.finish', 0, { locale: _unref(recapLanguage) })), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_select, {
          modelValue: languageChoice.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((languageChoice).value = $event)),
          label: _unref(t)('recap.language', 0, { locale: _unref(recapLanguage) }),
          class: "tw-my-3 tw-w-32",
          options: languageOptions
        }, null, 8, ["modelValue", "label"])
      ])
    ]),
    _: 1
  }))
}
}

})